import { Module } from 'vuex';
import { TeamRequestsStateStorable, teamRequests } from './manager/teamRequestsPageStore';
import { StemdoersStateStorable, stemdoers } from './manager/stemdoersPageStore';
import { ProjectsStateStorable, projects } from './manager/projectsPageStore';
export interface ManagerStateStorable {
  teamRequests: TeamRequestsStateStorable;
  stemdoers: StemdoersStateStorable;
  projects: ProjectsStateStorable;
}

export const manager: Module<ManagerStateStorable, any> = {
  namespaced: true,
  modules: {
    teamRequests,
    stemdoers,
    projects
  }
};
